{
    "name": "@dds/react",
    "author": "DellDesignSystem@Dell.com",
    "license": "MIT",
    "version": "2.21.0",
    "private": false,
    "type": "module",
    "files": [
        "library"
    ],
    "main": "./library/index.umd.cjs",
    "module": "./library/index.js",
    "exports": {
        ".": {
            "import": "./library/index.js",
            "require": "./library/index.umd.cjs",
            "types": "./library/index.d.ts"
        },
        "./css/dds-main.css": "./library/css/dds-main.css",
        "./css/dds-reboot.css": "./library/css/dds-reboot.css",
        "./css/dds-fonts.css": "./library/css/dds-fonts.css",
        "./css/dds-icons.css": "./library/css/dds-icons.css",
        "./css/dds-helpers.css": "./library/css/dds-helpers.css",
        "./css/dds-templates.css": "./library/css/dds-templates.css",
        "./css/dds-components.css": "./library/css/dds-components.css"
    },
    "scripts": {
        "dev": "npm run build:tokens && vite",
        "build": "npm run build:tokens && npm run build:storybook && npm run build:app && npm run build:library",
        "build:tokens": "cd core && npm run build:tokens",
        "build:storybook": "storybook build",
        "build:app": "tsc && vite build --config vite.config.app.ts",
        "build:library": "tsc && vite build && vite build --config vite.config.styles.ts && node vite.post-build.js",
        "eslint:fix": "eslint --fix ./",
        "eslint:check": "eslint ./",
        "lint:check": "npm run eslint:check && npm run stylelint:check && npm run prettier:check",
        "lint:fix": "npm run eslint:fix && npm run stylelint:fix && npm run prettier:fix",
        "prepare": "husky install",
        "prettier:fix": "prettier -w ./",
        "prettier:check": "prettier --log-level log -c ./",
        "preview": "vite preview",
        "storybook": "storybook dev -p 6006",
        "stylelint:check": "stylelint ./**/*.scss",
        "stylelint:fix": "stylelint --fix ./**/*.scss",
        "test": "jest",
        "test:watch": "jest --watch",
        "test:coverage": "jest --coverage",
        "release:dry": "standard-version --dry-run --release-as",
        "release": "standard-version --release-as"
    },
    "dependencies": {
        "jest-junit": "^16.0.0",
        "react": "^18.3.1",
        "react-dom": "^18.3.1",
        "react-hook-form": "^7.54.2",
        "react-router-dom": "^6.26.2"
    },
    "devDependencies": {
        "@babel/preset-env": "^7.26.0",
        "@babel/preset-react": "^7.25.9",
        "@babel/preset-typescript": "^7.26.0",
        "@commitlint/cli": "^17.8.1",
        "@commitlint/config-conventional": "^17.8.1",
        "@storybook/addon-essentials": "7.2.3",
        "@storybook/addon-interactions": "7.2.3",
        "@storybook/addon-links": "7.2.3",
        "@storybook/blocks": "7.2.3",
        "@storybook/manager-api": "7.2.3",
        "@storybook/react": "7.2.3",
        "@storybook/react-vite": "7.2.3",
        "@storybook/testing-library": "0.2.0",
        "@storybook/theming": "7.2.3",
        "@testing-library/jest-dom": "^6.6.3",
        "@testing-library/react": "^16.0.1",
        "@testing-library/user-event": "^14.5.2",
        "@types/jest": "^29.5.14",
        "@types/node": "^22.10.1",
        "@types/prettier": "^2.7.3",
        "@types/react": "^18.3.12",
        "@types/react-dom": "^18.3.1",
        "@typescript-eslint/eslint-plugin": "^5.62.0",
        "@typescript-eslint/parser": "^5.62.0",
        "@vitejs/plugin-react": "^4.3.4",
        "eslint": "^8.57.0",
        "eslint-config-prettier": "^8.10.0",
        "eslint-import-resolver-typescript": "^3.6.3",
        "eslint-plugin-import": "^2.31.0",
        "eslint-plugin-react-hooks": "^4.6.2",
        "eslint-plugin-react-refresh": "^0.3.5",
        "eslint-plugin-storybook": "^0.6.15",
        "husky": "^8.0.3",
        "identity-obj-proxy": "^3.0.0",
        "jest": "^29.7.0",
        "jest-environment-jsdom": "^29.7.0",
        "lint-staged": "^13.3.0",
        "prettier": "^2.8.8",
        "sass": "^1.89.2",
        "standard-version": "^9.5.0",
        "storybook": "7.2.3",
        "stylelint": "16.11.0",
        "stylelint-config-sass-guidelines": "12.1.0",
        "stylelint-order": "^6.0.4",
        "ts-node": "^10.9.2",
        "typescript": "^5.7.2",
        "vite": "^4.5.3",
        "vite-plugin-dts": "^3.9.1",
        "vite-plugin-svgr": "^4.5.0"
    }
}
